//import React from 'react'
//import Nav from './navbar-hp';
//import { Outlet, Link, NavLink } from "react-router-dom";
//import { useState, useEffect } from "react"
import "98.css";

export default function Login({onClose}) {

    function handleKeyDown(e) {
        //console.log(e.key)
        if (e.key === 'Enter') {
            document.querySelector('.login-buttons button').click();
        }
    }

    return (
        <>

        <div id="startup">
            <div className="window" data-name="Login">

                <div className="title-bar">
                    <div className="title-bar-text">Welcome to Be Lucky</div>
                </div>

                <div className="window-body">
                    <div id="login">
                        <p>Select user name:</p>
                        <div className="users">
                            <input id="user1" name="users" type="radio"/>
                            <input id="user2" name="users" type="radio"/>
                            {/* <input id="user3" name="users" type="radio"/> */}

                            <label htmlFor="user1" id="user1-label">Be Lucky</label>
                            <label htmlFor="user2" id="user2-label">Guest</label>
                            {/* <label htmlFor="user3" id="user3-label">User 3</label> */}
                        </div>
                        <div className="field-row-stacked">
                            <label htmlFor="login-password">Password:</label>
                            <input id="login-password" type="password" onKeyDown={handleKeyDown} defaultValue="password"/>
                        </div>
                        <p>Hint: password</p>
                    </div>
                    <div className="login-buttons">
                        <button className="" onClick={onClose} tabIndex={0} type="submit" value="OK">OK</button>
                    </div>
                </div>

                
            </div>
        </div>

        </> 
    )
}